export default __webpack_public_path__ + "static/partnerIcon10-3745a829e7a5ed3b420dcc8bfcf70b84.svg";